import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import LeftSVG from "../assets/page_svg/vector.svg";
import RightSVG from "../assets/page_svg/vision.svg";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsappButton";
const Vision: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#F9DCAC" }}>
      {/* Hero Section */}
      <div className="relative z-10">
        <section className="relative py-24 px-4 sm:px-6 lg:px-8 min-h-[65vh] flex flex-col items-center justify-center">
          <div className="absolute inset-0 pointer-events-none z-0">
            {/* Left SVG */}
            <img
              src={LeftSVG}
              alt="left decoration"
              className="absolute top-0 left-0 max-w-[150px] sm:max-w-[220px] md:max-w-[250px] lg:max-w-[280px] w-full opacity-100"
            />
            {/* Right SVG */}
            <img
              src={RightSVG}
              alt="right decoration"
              className="absolute bottom-0 right-0 max-w-[220px] sm:max-w-[250px] md:max-w-[320px] lg:max-w-[420px] w-full opacity-100"
            />
          </div>
          <div className="max-w-6xl mx-auto relative z-10">
            <div className="text-center">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-child font-semibold text-black mb-6 leading-tight">
                {t("vision.title")}
              </h1>
              <p className="text-xl md:text-2xl text-neutral-900 mb-10 max-w-4xl mx-auto leading-relaxed">
                {t("vision.subtitle")}
              </p>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            {/* 2.1 Our Vision on Childcare */}
            <div className="mb-16">
              <div className="bg-[#FBEACD] rounded-3xl p-8">
                <h2 className="text-3xl font-child font-semibold text-black mb-8 text-center">
                  {t("vision.section21.title")}
                </h2>
                <p className="text-lg text-neutral-900 leading-relaxed text-center">
                  {t("vision.section21.content")}
                </p>
              </div>
            </div>

            {/* 2.2 Our view of children */}
            <div className="mb-16">
              <div className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft space-y-6">
                <h2 className="text-3xl font-child font-semibold text-black mb-8 text-center">
                  {t("vision.section22.title")}
                </h2>
                <p className="text-lg text-neutral-800 leading-relaxed">
                  {t("vision.section22.content")}
                </p>
                <div className="flex flex-col md:flex-row md:justify-evenly">
                  <div className="bg-[#f3d6d1] rounded-2xl p-6 mx-3 mb-6 md:mb-0">
                    <h3 className="text-xl font-child font-whasemibold text-purple-900 mb-3">
                      {t("vision.section22.piaget.title")}
                    </h3>
                    <p className="text-neutral-800 leading-relaxed">
                      {t("vision.section22.piaget.content")}
                    </p>
                  </div>

                  <div className="bg-[#f3d6d1] rounded-2xl p-6 mx-3">
                    <h3 className="text-xl font-child font-semibold text-purple-900 mb-3">
                      {t("vision.section22.bowlby.title")}
                    </h3>
                    <p className="text-neutral-800 leading-relaxed">
                      {t("vision.section22.bowlby.content")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 2.3 Our vision on development */}
            <div className="mb-16">
              <div className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft space-y-6">
                <h2 className="text-3xl font-child font-semibold text-black mb-8 text-center">
                  {t("vision.section23.title")}
                </h2>
                <p className="text-lg text-neutral-800 leading-relaxed">
                  {t("vision.section23.content")}
                </p>

                <div className="bg-yellow-50 rounded-2xl p-6">
                  <h3 className="text-xl font-child font-semibold text-yellow-800 mb-3">
                    {t("vision.section23.playTool.title")}
                  </h3>
                  <p className="text-neutral-800 leading-relaxed">
                    {t("vision.section23.playTool.content")}
                  </p>
                </div>

                <div className="bg-purple-50 rounded-2xl p-6">
                  <h3 className="text-xl font-child font-semibold text-purple-800 mb-3">
                    {t("vision.section23.thematicApproach.title")}
                  </h3>
                  <p className="text-neutral-800 leading-relaxed">
                    {t("vision.section23.thematicApproach.content")}
                  </p>
                </div>

                <div className="bg-orange-50 rounded-2xl p-6">
                  <h3 className="text-xl font-child font-semibold text-orange-800 mb-3">
                    {t("vision.section23.staffRole.title")}
                  </h3>
                  <p className="text-neutral-800 leading-relaxed">
                    {t("vision.section23.staffRole.content")}
                  </p>
                </div>
              </div>
            </div>

            {/* 2.4 Correcting and confirming */}
            <div className="mb-16">
              <div className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft space-y-6">
                <h2 className="text-3xl font-child font-semibold text-black mb-8 text-center">
                  {t("vision.section24.title")}
                </h2>
                <div className="bg-red-50 rounded-2xl p-6">
                  <h3 className="text-xl font-child font-semibold text-red-800 mb-3">
                    {t("vision.section24.behaviorCommunication.title")}
                  </h3>
                  <p className="text-neutral-800 leading-relaxed">
                    {t("vision.section24.behaviorCommunication.content")}
                  </p>
                </div>

                <div className="bg-indigo-50 rounded-2xl p-6">
                  <h3 className="text-xl font-child font-semibold text-indigo-800 mb-3">
                    {t("vision.section24.respectfulApproach.title")}
                  </h3>
                  <p className="text-neutral-800 leading-relaxed">
                    {t("vision.section24.respectfulApproach.content")}
                  </p>
                </div>

                <div className="bg-teal-50 rounded-2xl p-6">
                  <h3 className="text-xl font-child font-semibold text-teal-800 mb-3">
                    {t("vision.section24.positiveReinforcement.title")}
                  </h3>
                  <p className="text-neutral-800 leading-relaxed">
                    {t("vision.section24.positiveReinforcement.content")}
                  </p>
                </div>
              </div>
            </div>

            {/* 2.5 Basic principles in practice */}
            <div className="mb-16">
              <div className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft">
                <h2 className="text-3xl font-child font-semibold text-black mb-8 text-center">
                  {t("vision.section25.title")}
                </h2>
                <p className="text-lg text-neutral-800 leading-relaxed mb-8">
                  {t("vision.section25.content")}
                </p>

                <div className="space-y-6">
                  <div className="bg-blue-50 rounded-2xl p-6">
                    <h3 className="text-xl font-child font-semibold text-blue-800 mb-3">
                      {t(
                        "vision.section25.principles.sensitiveResponsiveness.title"
                      )}
                    </h3>
                    <p className="text-neutral-800 leading-relaxed">
                      {t(
                        "vision.section25.principles.sensitiveResponsiveness.content"
                      )}
                    </p>
                  </div>

                  <div className="bg-green-50 rounded-2xl p-6">
                    <h3 className="text-xl font-child font-semibold text-green-800 mb-3">
                      {t("vision.section25.principles.respectAutonomy.title")}
                    </h3>
                    <p className="text-neutral-800 leading-relaxed">
                      {t("vision.section25.principles.respectAutonomy.content")}
                    </p>
                  </div>

                  <div className="bg-yellow-50 rounded-2xl p-6">
                    <h3 className="text-xl font-child font-semibold text-yellow-800 mb-3">
                      {t("vision.section25.principles.structureRhythm.title")}
                    </h3>
                    <p className="text-neutral-800 leading-relaxed">
                      {t("vision.section25.principles.structureRhythm.content")}
                    </p>
                  </div>

                  <div className="bg-purple-50 rounded-2xl p-6">
                    <h3 className="text-xl font-child font-semibold text-purple-800 mb-3">
                      {t("vision.section25.principles.activeInvolvement.title")}
                    </h3>
                    <p className="text-neutral-800 leading-relaxed">
                      {t(
                        "vision.section25.principles.activeInvolvement.content"
                      )}
                    </p>
                  </div>

                  <div className="bg-orange-50 rounded-2xl p-6">
                    <h3 className="text-xl font-child font-semibold text-orange-800 mb-3">
                      {t(
                        "vision.section25.principles.positiveInteraction.title"
                      )}
                    </h3>
                    <p className="text-neutral-800 leading-relaxed">
                      {t(
                        "vision.section25.principles.positiveInteraction.content"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 2.6 Evaluation and Update */}
            <div className="mb-16">
              <div className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft">
                <h2 className="text-3xl font-child font-semibold text-black mb-8 text-center">
                  {t("vision.section26.title")}
                </h2>
                <div className="bg-teal-50 rounded-2xl p-6">
                  <p className="text-lg text-neutral-800 leading-relaxed">
                    {t("vision.section26.content")}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-[#FBEACD] rounded-3xl p-8 shadow-soft">
              <h2 className="text-3xl font-child font-semibold text-black mb-8 text-center">
                {t("vision.documentsSection.documents")}
              </h2>

              <div className="flex flex-col items-center gap-15">
                <a
                  href="https://drive.google.com/file/d/1NddKUihhauKeHWFqVRcmEjYT5TloJq-K/view"
                  target="_blank"
                  className="block w-full max-w-[350px] text-center bg-amber-200 text-gray-800 px-6 py-3 m-3 rounded-xl text-lg font-medium hover:bg-amber-300 transition"
                  rel="noreferrer"
                >
                📄 {t("vision.documentsSection.kdv")}
                </a>

                <a
                  href="https://drive.google.com/file/d/16rJKywEkRWqlhp0mzGt-mVWqpg8UgNk_/view"
                  target="_blank"
                  className="block w-full max-w-[350px] text-center bg-amber-200 text-gray-800 px-6 py-3 m-3 rounded-xl text-lg font-medium hover:bg-amber-300 transition"
                  rel="noreferrer"
                >
                📄 {t("vision.documentsSection.bso")}
                </a>

                <a
                  href="https://drive.google.com/file/d/1icLUO_V2X3SeSXgHfLOY0VlfIYWRpnQ3/view"
                  target="_blank"
                  className="block w-full max-w-[350px] text-center bg-amber-200 text-gray-800 px-6 py-3 m-3 rounded-xl text-lg font-medium hover:bg-amber-300 transition"
                  rel="noreferrer"
                >
                📄 {t("vision.documentsSection.safety")}
                </a>
              </div>
            </div>

          </div>
        </section>
      </div>

      {/* WhatsApp Floating Contact Button */}
      <WhatsAppButton />
      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default Vision;
